import { Icon, ICON_SIZES } from "src/apps/components/icon/Icon";
import { ICON_PATHS } from "src/apps/components/icon/IconSVGPaths";
import { TextBold } from "src/apps/components/typography/Texts";
import { ActorIdentity } from "src/contexts/documentationArea/domain/ActorIdentity";
import { DocumentationAreaTypes } from "src/contexts/documentationArea/domain/DocumentationAreaTypes";
import styled, { useTheme } from "styled-components";
import { useTranslations } from "src/apps/hooks/useTranslations";

type DefaultActorInfoProps = {
  identity: ActorIdentity | null;
  type: DocumentationAreaTypes | null;
};

const ACCENT_KEYS = {
  default_actor_name: "documentation_area.default_actor_info.actor_name",
} as const;

export const DefaultActorInfo = ({ identity, type }: DefaultActorInfoProps) => {
  const { blackColor } = useTheme();
  const { t } = useTranslations();

  if (!identity) return null;

  const isForCompanies = type === DocumentationAreaTypes.COMPANY;
  const nameIconPath = isForCompanies ? ICON_PATHS.COMPANY : ICON_PATHS.USER;

  const name = isForCompanies
    ? identity.getRepresentedEntity().getLegalName()
    : (identity.getRepresentative()?.getFullName() ?? t(ACCENT_KEYS.default_actor_name));

  const idNumber = identity.getRepresentative().getIdNumber()?.number;

  return (
    <ActorInfoContainer>
      {name ? (
        <ActorInfoElement>
          <Icon path={nameIconPath} size={ICON_SIZES.s24} color={blackColor} />
          <TextBold className="text mp-mask">{name}</TextBold>
        </ActorInfoElement>
      ) : null}
      {idNumber ? (
        <ActorInfoElement>
          <Icon path={ICON_PATHS.ID_CARD_ICON} size={ICON_SIZES.s24} color={blackColor} />
          <TextBold className="text mp-mask">{idNumber}</TextBold>
        </ActorInfoElement>
      ) : null}
    </ActorInfoContainer>
  );
};

const ActorInfoElement = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.375rem;
  align-items: center;
`;

const ActorInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
`;
